import { CloudUpload } from "@assets/icons";
import { Spinner } from "@components/ui/spinner";
import { endpoint } from "@services/api.services";
import { uploadToGallery } from "@services/giveAwayServices";
import { useMutation } from "@tanstack/react-query";
import { usePostData } from "@utils/query/index.query";
import { useRef } from "react";
import { toast } from "sonner";

const UploadToCloud = ({
  onChange,
  value,
  id,
  ...props
}: {
  onChange: (e: any) => void;
  value: string;
  id: string;
}) => {
  // const { mutate, isPending } = usePostData();
  const fileInputRef = useRef<HTMLInputElement>(null);
  console.log("THIS IS THE UPLOADTOCLOUD!!!!");
  const { mutate: uploadToGalleryMutation, isPending } = useMutation({
    mutationFn: uploadToGallery,
    onSuccess: (response) => {
      // Extract the image URL/ID from the response - adjust based on your API response structure
      const uploadedImageUrl = response.data?.image || response.data?.url;
      console.log("This is the uploaded image url", uploadedImageUrl);
    },
    onError: (error: any) => {
      toast.error("Gallery upload failed:");
      // setIsUploading(false);
      // Handle error - show toast notification, etc.
    },
  });

  // const uploadToCloud = (file: File) => {
  //   mutate(
  //     {
  //       data: {
  //         image: file,
  //       },
  //       endpoint: endpoint["uploadimage"],
  //       key: "uploadFile",
  //     },
  //     {
  //       onSuccess: ({ data }) => {
  //         onChange(data.image);
  //       },
  //     }
  //   );
  // };

  return (
    <div className="my-2">
      <div
        className="p-2 w-full truncate rounded-md border-green-500 border-dashed bg-green-50  h-[300px] flex text-center flex-col items-center justify-center"
        onClick={() => {
          fileInputRef.current?.click();
        }}
        style={{ backgroundImage: `url(${value})`, backgroundSize: "cover" }}
      >
        {isPending ? (
          <div className="flex items-center justify-center gap-2">
            Pending... <Spinner />
          </div>
        ) : value ? (
          <div className="max-w-[250px] text-[10px] truncate w-fit text-white flex flex-col justify-center items-center space-x-2 cursor-pointer">
            {value.split("/").pop()}{" "}
            <span className="underline text-[10px]">replace</span>
          </div>
        ) : (
          <>
            <CloudUpload />
            <p className="text-green-600 text-[14px]">
              Drag and drop a image to upload
              <br />
              PNG, JPG and JPEG up to 500 MB
              <br />
              Recommended Size: 1180 x 800 px
            </p>
          </>
        )}
      </div>
      <input
        {...props}
        type="file"
        className="hidden"
        ref={fileInputRef}
        disabled={isPending}
        accept="image/*"
        onChange={(e) => {
          console.log("THE FILE WAS UPLOADED");
          const selectedFile = e.target.files?.[0];
          if (selectedFile) {
            const formData = new FormData();
            formData.append("image", selectedFile);
            uploadToGalleryMutation({ formData });
          }
          // Reset the input to allow selecting the same file again
          if (e.target) {
            e.target.value = "";
          }
        }}
      />
    </div>
  );
};

export default UploadToCloud;
